import React, { useEffect, useState } from "react";
import { MultiSelect, MultiSelectChangeParams } from "primereact/multiselect";
import T from "services/lang/LanguageService";
import { useGetProductTemplateConfig } from "api/api-hooks/product-templates-hooks";
import { InputText } from "primereact/inputtext";
import { IProductTemplateDropdownChangeParams } from "../product-template/ProductTemplateDropdown";

interface IHiddenColumnsDropdownProps {
  value?: Array<string>;
  onChange?: (e: MultiSelectChangeParams) => void;
  selectedTemplate?: IProductTemplateDropdownChangeParams;
  className?: string;
  id?: string;
  disabled?: boolean;
  showClear?: boolean;
  setProductTemplateCreationDate?: (date: Date) => void;
}

const dateTimeType = "DATETIME";

export default function ProductTemplateColumnsDropdown(props: IHiddenColumnsDropdownProps) {
  const [allSelections, setAllSelections] = useState<object[]>([]);
  const query = useGetProductTemplateConfig(
    props.selectedTemplate?.refName!,
    `${props.selectedTemplate?.value}`,
    {
      enabled: !!props.selectedTemplate?.refName && !Number.isNaN(props.selectedTemplate?.value),
    }
  );

  useEffect(() => {
    if (query.data) {
      const selections = query.data.data?.attributes
        .filter(attribute => attribute.type === dateTimeType)
        .map((element: any) => ({
          label: element.displayName,
          value: element.referenceName,
        }));
      if (props.setProductTemplateCreationDate && query.data.dateCreated) {
        props.setProductTemplateCreationDate(new Date(query.data.dateCreated));
      }
      setAllSelections(selections ?? []);
    }
  }, [query.data]);

  const onChange = (e: MultiSelectChangeParams) => {
    props.onChange?.(e);
  };

  if (!props.selectedTemplate?.refName || Number.isNaN(props.selectedTemplate?.value)) {
    return <InputText id={props.id} placeholder={T("message.product-template-is-not-selected")} disabled />;
  }
  return (
    <>
      {query.error && (
        <InputText id={props.id} placeholder={T("error.product-template-selection-error")} disabled />
      )}
      {query.isLoading && !query.error && (
        <InputText id={props.id} placeholder={T("message.product-templates-loading")} disabled />
      )}
      {query.isSuccess && (
        <MultiSelect
          placeholder={T("action.select-columns")}
          id={props.id}
          className={props.className}
          value={props.value || []}
          options={allSelections}
          onChange={onChange}
          showClear={props.showClear}
          disabled={props.disabled}
          maxSelectedLabels={1}
        />
      )}
    </>
  );
}
